import React from 'react';

import DefaultSolutionTemplate from './default-solution-template';
import SectionHero from '../components/SectionHero';

const PortalsSolutionTemplate = (props) => (
  <DefaultSolutionTemplate {...props}>
    <SectionHero
      title="Empower customers and employees"
      description="Give customers the information they seek, and employees the information they need, all with using fewer resources to maintain a better service. It’s a win-win."
    />
  </DefaultSolutionTemplate>
);

export default PortalsSolutionTemplate;
